'use strict';

angular.module('atex.dam').directive('damFieldEditorTextarea', function($compile) {
  return {
    restrict : 'E',
    replace : true,
    scope : true,

    link : function(scope, element, attrs) {
      
      var ckeditorValue = attrs.type==='ckeditor' ? 'wysiwyg' : '';
      
      var html = "<span>";
           html += "<span ng-if='editingCollection'>";
             html += "<b ng-click='show(" + attrs.fieldName + "form);$event.stopPropagation();'><i class='fa fa-edit'></i> " + attrs.label + ":</b>";
             html += "<form name='" + attrs.fieldName + "form' " + ckeditorValue + " ng-model='field." + attrs.fieldName + "' ng-click='$event.stopPropagation();' editable-form blur='submit' ng-keydown='$event.stopPropagation();' class='editable-form'>";
               html += "<span editable-textarea='field." + attrs.fieldName + "' e-ng-change='fieldChanged($data, \"" + attrs.fieldName + "\")' ng-click='show(" + attrs.fieldName + "form);' e-class='editable-description' onaftersave='update();' e-required>";
                 html += "<p ng-bind-html='to_trusted(field." + attrs.fieldName + ", full)' style='white-space: pre-wrap;'></p>";
               html += "</span>";
             html += "</form>";
             html += "<br/>";
           html += "</span>";
           html += "<span ng-if='!editingCollection && data." + attrs.fieldName + "'>";
             html += "<b>" + attrs.label + ":</b> ";
             html += "<span ng-bind-html='to_trusted(data." + attrs.fieldName + ", full)'></span>";
             html += "<br/>";
           html += "</span>";
         html += "</span>";
        
      var linkFn = $compile(html);
      var content = linkFn(scope);
      element.append(content);
    }
  };
});
